import script from "./SuggestionDropdown.vue?vue&type=script&setup=true&lang=ts"
export * from "./SuggestionDropdown.vue?vue&type=script&setup=true&lang=ts"

import "./SuggestionDropdown.vue?vue&type=style&index=0&id=809da07c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-809da07c"]])

export default __exports__